export default __webpack_public_path__ + "static/media/bike-friendly-accommodation.c7d9dfbe.svg";